// site logo
import {Link} from 'react-router-dom';
import icon from '../../media/icon.png';

import { UserForm } from "../../services/srvc-utilities";

export default function WebbIconLite() {

  return (
  <>
    <div className="">
      <Link to={`/${UserForm()}/home`}>
        <img src={icon}
          className=""
          width="30" height="30" alt="..."
        ></img>      
      </Link>
    </div>

  </>
  )
}